import { Box, Grid, Paper, Typography } from '@mui/material';
import CountrySplit from './CountrySplit.jsx';
import TopRegions from './TopRegions.jsx';
import Sources from './Sources.jsx';
import useSupplyOverview from './hooks/useSupplyOverview.js';
import SingleCalendarWithShortcuts from '~/components/SingleCalendarWithShortcuts.jsx';

export default function SupplyOverview() {
  const {
    countries,
    sources,
    isCountryLoading,
    isSourceLoading,
    countryError,
    dateValue,
    selectedCountry,
    dateTempValue,
    handleSelectedCountryChange,
    setDateValue,
    setDateTempValue,
  } = useSupplyOverview();

  return (
    <Paper
      elevation={2}
      className="sas-overview-card"
      sx={{ bgcolor: 'background.paper', borderRadius: 2 }}>
      <Box className="sas-supply-header">
        <Typography variant="h6">Supply Overview</Typography>
        <SingleCalendarWithShortcuts
          dateValue={dateValue}
          setDateValue={setDateValue}
          dateTempValue={dateTempValue}
          setDateTempValue={setDateTempValue}
        />
      </Box>

      <Grid
        container
        spacing={2}>
        <Grid size={12}>
          <CountrySplit
            countries={countries}
            isLoading={isCountryLoading}
            onSelectedCountryChange={handleSelectedCountryChange}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TopRegions
            selectedCountry={selectedCountry}
            isLoading={isCountryLoading}
            hasError={Boolean(countryError)}
            startDate={dateValue[0].format('YYYY-MM-DD')}
            endDate={dateValue[1].format('YYYY-MM-DD')}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Sources
            sources={sources}
            isLoading={isSourceLoading}
            startDate={dateValue[0].format('YYYY-MM-DD')}
            endDate={dateValue[1].format('YYYY-MM-DD')}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
